export const REPORT_DECIMALS = {
  unitaryValue: 2,
  quantity: 0,
  totalValueByProduct: 2,
  totalValueByOrder: 2,
  totalDiscountInOrder: 2,
};

/**
 * Converte um valor cru em Number, ou null quando ausente/ inválido.
 * Aceita number, "1234.56", "1,234.56" (vírgula de milhar), "R$ 1234.56".
 */
export const parseReportNumber = (raw) => {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === "number") return Number.isFinite(raw) ? raw : null;

  const trimmed = String(raw).trim();
  if (trimmed === "") return null;

  // Remove tudo que não seja dígito, ponto decimal ou sinal (elimina símbolos
  // de moeda, espaços e vírgulas de milhar do formato internacional).
  const cleaned = trimmed.replace(/[^\d.-]/g, "");
  if (cleaned === "" || cleaned === "-" || cleaned === ".") return null;

  const parsed = Number(cleaned);
  return Number.isFinite(parsed) ? parsed : null;
};

const roundTo = (value, decimals) => {
  const factor = Math.pow(10, decimals);
  return Math.round((value + Number.EPSILON) * factor) / factor;
};

/**
 * Formata para exibição na UI no padrão pt-BR (vírgula decimal, ponto de milhar).
 * Retorna "" para nulo/inválido.
 */
export const formatReportNumber = (raw, decimals = 2) => {
  const parsed = parseReportNumber(raw);
  if (parsed === null) return "";
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(parsed);
};

/**
 * Valor para a célula do export: NÚMERO real (arredondado às casas do campo),
 * para Excel/Sheets/Power BI interpretarem como número. Retorna "" (célula
 * vazia) para nulo/inválido, sem quebrar o arquivo.
 */
export const toReportNumberCell = (raw, decimals = 2) => {
  const parsed = parseReportNumber(raw);
  if (parsed === null) return "";
  return roundTo(parsed, decimals);
};
